const ApiRoute = "/MVC/LocationPortal";
export default ApiRoute;
